<p>denied-drawings works!</p>
